import type { InquiryStatusKey } from 'components/ProjectInquiry/projectInquiryStatus';

//
// The filter groups of the send rooms, Uitvraag bedrijfsmiddelen and Uitvraag uitkomsten (see FilterAssetGroupKeys for
// the format): a value is `{group}{value}`; a responsible person's value is the user id.
//
export enum FilterInquirySendGroupKeys {
  status = 'status$',
  responsible = 'responsible$',
}

/** The filter value of a role's status, typed so a renamed status does not leave a chip that matches nothing. */
export const getInquirySendStatusFilterValue = (key: InquiryStatusKey): string =>
  FilterInquirySendGroupKeys.status + key;
